/**
 *  For specific enums for the values you need to pass for tracking check
 *  https://docs.google.com/spreadsheets/d/1f90_U41depIwExovFHg1ACFUL0C9m5QSey64OU6H1Do/edit#gid=310863332
 */
import { InteractionEvent, type TrackingEventParams } from '@/helpers/GTM/types';
import { isServer } from '../Platform/platform';

export function isGTMEnabled(): boolean {
  return !isServer() && !!window.dataLayer;
}
export function trackEvent(
  eventName: InteractionEvent,
  eventParams: TrackingEventParams = {},
): void {
  if (!isGTMEnabled()) {
    return;
  }
  window.dataLayer.push({
    event: eventName,
    ...eventParams,
  });
}
